export const normalizeProductUrl = (slug: string) =>
  slug.charAt(0) === '/' ? slug : `/${slug}`
